module.exports = __webpack_public_path__ + "img/Share-new.b4b3258f.svg";